'use strict'

module.exports = () => {
	let btn = document.querySelector('.fbRegister, .fbLogin')
	if(btn){
		btn.addEventListener('click', () => {
			FB.login(function(response){
				submit(response)
			})
		})
	}


	function submit(response){
		console.log(response)
		const form = document.querySelector('.facebookForm')
		form.querySelector('input[name="accessToken"]').value = response.authResponse.accessToken
		let el = form.querySelector('input[name="signedRequest"]')
		if(el){
			el.value = response.authResponse.signedRequest
		}
		el = form.querySelector('input[name="id"]')
		if(el){
			el.value = response.authResponse.userID
		}
		form.submit()
	}

}



global.fbAsyncInit = function() {
	console.log('fbAsyncInit()')
	if(global.FB){
		global.FB.init({
			appId: global.facebookAppId,
			cookie: true,
			xfbml: true,
			version: 'v2.8'
		})
	}
	else{
		console.log('FB not found')
	}
}


/*
global.facebookSignInInit = function(){
	FB.getLoginStatus(function(response){
		if (response.status === 'connected') {
			submit(response)
		}
		else if (response.status === 'not_authorized') {
			console.log('Not authorized')
		}
		else {
			console.log('Not logged into FB')
		}
	})
}
*/



